module.exports = __webpack_public_path__ + "static/industries-logistic-image-792a33d1b9ac1af75dd23c968caad096.jpg";